import * as Yup from "yup";

const AgendamentoServicosValidator = Yup.object().shape({
  clienteId: Yup.number().nullable().optional(),
  clienteNome: Yup.string().required("Nome do cliente"),
  servicoId: Yup.number().when("configuracaoTempoServico", (config) => {
    return config
      ? Yup.number().required("Serviço")
      : Yup.number().nullable().optional();
  }),
  celular: Yup.string().required("Celular"),
  periodo: Yup.lazy(() =>
    Yup.date()
      .nullable()
      .required("Período")
      .min(new Date(), "Período após o horário atual"),
  ),
  observacao: Yup.string().nullable().optional(),
});

export default AgendamentoServicosValidator;
